<script>
    import {Container,Input,Button,Field} from 'svelte-chota';
    import {router} from 'tinro';
    import Header from './Header.svelte';
    import {aoviSvelte} from 'aovi-svelte';
    import {api} from './../lib/api.js'; 

    const form = aoviSvelte({
        name: '',
        repo: ''
    });


    let loading = false;
    async function doCreateProject(){
        loading = true;
        let result = await api.post('/project',form.get());
        result.error ? form.load(result.error.aovi) : router.goto('/admin/projects');
        loading=false;
    }
</script>

<Header title="Create project" button="Cancel" link="/admin/projects" type="error"/>

<Container class="center-500">

    <Field label="Project name" error={$form.err.name}>
        <Input  bind:value={$form.name}/>
    </Field>

    <Field label="Github repository URL" error={$form.err.repo}>
        <Input  bind:value={$form.repo}/>
    </Field>

    <p class="text-center">
        <Button primary on:click={doCreateProject} {loading}>Create</Button>
    </p>
</Container>